import { Bill } from '@/interfaces/Bill';
import { fetch } from '@/utils/fetch';
import { buildQueryString } from '@/utils/queryParams';

interface Props {
  outletId: string;
  counterNumber: string;
  amount?: number;
  selectedTipPercentage?: number;
  signal?: AbortSignal;
  locale?: string;
}

export const getOrderDetails = ({
  outletId,
  amount,
  counterNumber,
  selectedTipPercentage,
  signal,
  locale,
}: Props): Promise<Bill> => {
  const queryString = buildQueryString({
    amount,
    tipPercentage: selectedTipPercentage,
    isServiceFeeEnabled: true,
    language: locale,
  });

  const url = `/personalization-public/dine-in/outlets/${outletId}/counters/${counterNumber}${queryString ? `?${queryString}` : ''}`;

  return fetch.get(url, { signal }).then(response => response.data);
};
